module.exports = "/static/js/c71c325ff19913af72cd296a55950a5e.png";